/* @flow */
import React from 'react';

import CSSTransitionGroup from 'react-addons-css-transition-group';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import RecentMessages from 'groups/components/RecentMessages.jsx';

import styles from './styles/RecentView.css';

type Props = {
  hide: Function,
};

class RecentView extends React.Component {
  props: Props;

  render() {
    const { hide } = this.props;

    return (
      <div>
        <div className={styles.recentViewMask} onClick={hide} />
        <Link className={styles.closeRecent} onClick={hide}>
          <Glyph name="close-btn" />
        </Link>
        <div className={styles.recentView}>
          <CSSTransitionGroup
            className={styles.recentViewInner}
            transitionAppear
            transitionEnterTimeout={1000}
            transitionAppearTimeout={1000}
            transitionLeaveTimeout={1000}
            transitionName={styles}>
            <RecentMessages key="recent" />
          </CSSTransitionGroup>
        </div>
      </div>
    );
  }
}


export default RecentView;



// WEBPACK FOOTER //
// ./src/chat/components/RecentView.jsx